/** The show sheet, wired to the app's queue and set-aside list. */
import type { SimklClient } from "@/api/client";
import { ShowSheet } from "@/screens/Show/ShowSheet";
import type { OutboxAction } from "@/store/outbox";
import type { useAside } from "@/store/useAside";
import type { useSheet } from "@/store/useSheet";

/** The show sheet, with the add action its footer needs when previewing. */
export function Sheet({
  sheet,
  client,
  pending,
  aside,
  onAction,
}: {
  sheet: ReturnType<typeof useSheet>;
  client: SimklClient;
  pending: boolean;
  aside: ReturnType<typeof useAside>;
  onAction: (action: OutboxAction) => void;
}) {
  return (
    <ShowSheet
      show={sheet.show}
      inLibrary={sheet.inLibrary}
      pending={pending}
      setAside={sheet.show !== null && aside.ids.has(sheet.show.show.ids.simkl)}
      onToggleAside={() => {
        if (sheet.show !== null) aside.toggle(sheet.show.show.ids.simkl);
      }}
      client={client}
      onAction={onAction}
      onAdd={() => {
        if (sheet.show !== null) {
          onAction({ kind: "add", simklId: sheet.show.show.ids.simkl, to: "watching" });
        }
      }}
      onClose={sheet.close}
    />
  );
}
